var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 180365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 180583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M2 5.22217V20.9999C2 21.5522 2.44772 21.9999 3 21.9999H21C21.5523 21.9999 22 21.5522 22 20.9999V5.22217C22 4.66988 21.5523 4.22217 21 4.22217H3C2.44772 4.22217 2 4.66988 2 5.22217Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M6.55572 2H6.3335C5.78121 2 5.3335 2.44772 5.3335 3V5.44444C5.3335 5.99673 5.78121 6.44444 6.3335 6.44444H6.55572C7.108 6.44444 7.55572 5.99673 7.55572 5.44444V3C7.55572 2.44772 7.108 2 6.55572 2Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M17.6666 2H17.4443C16.8921 2 16.4443 2.44772 16.4443 3V5.44444C16.4443 5.99673 16.8921 6.44444 17.4443 6.44444H17.6666C18.2188 6.44444 18.6666 5.99673 18.6666 5.44444V3C18.6666 2.44772 18.2188 2 17.6666 2Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M2 9.77783H22",
    stroke: "#8E8E8E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M7.55566 15.3334L10.7071 18.0347C11.1178 18.3867 11.734 18.3484 12.0979 17.9481L17.0001 12.5557",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon-event.26c62c0404b31ba7027370ecf6db8f2c.svg";
export { ForwardRef as ReactComponent };